import { TrashIcon, CleanIcon, SettingsIcon, EyeOffIcon } from '../../../components/Brand/Icon';
import usePageLayout from '../../../hooks/usePageLayout';
import '../UserResponsive.scss';
import React, { useRef } from "react";
import { Layout, Button } from 'antd';
import { Helmet } from "react-helmet";
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ButtonPanelReaction from '../../../components/Buttons/ButtonPanelReaction';
import WiwHeaderTitle from '../../../components/WiwHeaderTitle';
import { APP_ROUTES } from '../../../utils/constant';
import url from '../../../utils/url';

const { Header, Content, Footer } = Layout;

export default function UserControl() {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const ref_header = useRef(null);
	const ref_footer = useRef(null);
	const contentRef = useRef(null);

	const { contentHeight, contentTop } = usePageLayout(ref_header, ref_footer);


	const goToSettings = () => {
		navigate(url(APP_ROUTES.USER_SETTINGS));
	};

	return (
		<Layout className="app-layout user-page">
			<Helmet>
				<title>{t('user.control_title')}</title>
				<meta name="description" content={t('user.control_title')} />
			</Helmet>
			<Header className="header" ref={ref_header}>
				<WiwHeaderTitle title="WIW"></WiwHeaderTitle>
			</Header>
			<Content
				className="content-layot profile_page"
				style={{ height: contentHeight, top: contentTop, overflow: 'auto' }}
				ref={contentRef}
			>
				<div className="user-control profile-settings-buttons">
					<p>{t('user.control_delete')}</p>
					<Button onClick={goToSettings}>
						<TrashIcon className="nav-icon" />{t('user.btn_delete')}
					</Button>
					<p>{t('user.control_clear')}</p>
					<Button onClick={goToSettings}>
						<CleanIcon className="nav-icon" />{t('user.btn_clear_opinions')}
					</Button>
					<p>{t('user.control_hide_opinions')}</p>
					<Button onClick={goToSettings}>
						<EyeOffIcon className="nav-icon" />{t('user.btn_hide_opinions')}
					</Button>
					<p>{t('user.control_account')}</p>
					<Button onClick={goToSettings}>
						<SettingsIcon className="nav-icon" />{t('user.control_btn_settings')}
					</Button>
				</div>
			</Content>
			<Footer ref={ref_footer}>
				<ButtonPanelReaction />
			</Footer>
		</Layout>
	)
}
